/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const PostsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Posts = styled.ul`
  display: grid;
  gap: 24px;
  margin: 0;

  & > li {
    list-style: none;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: ${({ lastPageArticleAmount, isLastPage }) =>
      lastPageArticleAmount === 1 && isLastPage
        ? 'repeat(1, 378px)'
        : lastPageArticleAmount >= 7 && isLastPage
          ? 'repeat(4, 378px)'
          : lastPageArticleAmount <= 4 && isLastPage
            ? 'repeat(2, 378px)'
            : 'repeat(3, 378px)'};
  }
`;
